var _polygon, _polygon2, _polygon3, _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoInvitation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "30.25 31.53 37.73 38.03 37.73 24.05 30.25 31.53",
    fill: "none"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "17.71 31.57 10.27 24.12 10.27 38.03 17.71 31.57",
    fill: "none"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "24 31.41 13.62 40.41 34.38 40.41 24 31.41",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.74,28.94l1.95-1.69c.75-.65,1.87-.65,2.62,0l1.91,1.66,6.64-6.64V10.39H13.57v11.38l7.17,7.17Zm-3.18-15.3l11.95-.05h0c1.1,0,2,.89,2,1.99,0,1.1-.89,2-1.99,2.01l-11.95,.05h0c-1.1,0-2-.89-2-1.99,0-1.1,.89-2,1.99-2.01Zm0,5.88l11.95-.05h0c1.1,0,2,.89,2,1.99,0,1.11-.89,2-1.99,2.01l-11.95,.05h0c-1.1,0-2-.89-2-1.99,0-1.11,.89-2,1.99-2.01Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.82,17.55l-2.96-2.45v-6.71c0-1.11-.89-2-2-2h-7.67l-2.94-2.36c-.73-.59-1.77-.59-2.5,0l-2.97,2.37H11.57c-1.11,0-2,.89-2,2v7.21l-2.39,1.95c-.55,.36-.92,.97-.92,1.68v23.19c0,1.11,.89,2,2,2h31.46c1.11,0,2-.89,2-2V19.22c0-.7-.36-1.32-.91-1.67Zm-23.11,14.02l-7.44,6.46v-13.9l7.44,7.44Zm6.29-.16l10.38,9H13.62l10.38-9Zm6.25,.13l7.48-7.48v13.98l-7.48-6.49Zm3.61-21.14v11.88l-6.64,6.64-1.91-1.66c-.75-.65-1.87-.65-2.62,0l-1.95,1.69-7.17-7.17V10.39h20.29Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.57,17.64h0l11.95-.05c1.11,0,2-.9,1.99-2.01,0-1.1-.9-1.99-2-1.99h0l-11.95,.05c-1.11,0-2,.9-1.99,2.01,0,1.1,.9,1.99,2,1.99Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.57,23.52h0l11.95-.05c1.11,0,2-.9,1.99-2.01,0-1.1-.9-1.99-2-1.99h0l-11.95,.05c-1.11,0-2,.9-1.99,2.01,0,1.1,.9,1.99,2,1.99Z",
    fill: outlineColor
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInvitation);
export default __webpack_public_path__ + "static/media/ico-invitation.6d5b36d0e70334887646e7e135fffa46.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;